<template lang="pug">
  v-container#inv(fluid='' tag='section' style="padding: 0px;")
    v-snackbar(:timeout='5000' top='' right='' :color='snackbar.color' v-model='snackbar.show')
      | {{ snackbar.text }}
      v-btn(dark='' text='' @click.native='snackbar.show = false' icon='' style='background: transparent;')
        v-icon mdi-close
    v-dialog(fullscreen="" v-model='dialodPurchase')
      v-card
        purchase-note(@closeModalPurchase="closeModalPurchase" :noteToEdit="noteToEdit")
    v-dialog(fullscreen="" v-model='dialogSale')
      v-card
        sale-note(@closeModalSale="closeModalSale" :noteToEdit="noteToEdit")
    v-dialog(v-model='confirmationDialogPurchase' persistent max-width='290')
      v-card
        v-card-title.text-h5
          | Confirmar
        v-card-text ¿Estás seguro de anular este registro?
        v-card-actions
          v-spacer
          v-spacer(style="text-align: right;")
            v-btn(color='red darken-1' text='' @click='confirmationDialogPurchase = false')
              | Cancelar
            v-btn.success-btn(text='' @click='anulNotePurchase' :loading="loadingSave")
              | Aceptar
    v-dialog(v-model='confirmationDialogSale' persistent max-width='290')
      v-card
        v-card-title.text-h5
          | Confirmar
        v-card-text ¿Estás seguro de anular este registro?
        v-card-actions
          v-spacer
          v-spacer(style="text-align: right;")
            v-btn(color='red darken-1' text='' @click='confirmationDialogSale = false')
              | Cancelar
            v-btn.success-btn(text='' @click='anulNoteSale' :loading="loadingSave")
              | Aceptar
    base-material-card.px-5.py-3(icon='mdi-clipboard-text' title='Lista de Notas' style='min-height: 100vh;')
      v-alert(v-model="alertDataSend" dismissible dense='' border='left' type='warning')
        | Las notas de compra o venta son documentos sin valor tributario que generan un ingreso o egreso y control de inventario. Al no ser de valor tributario esta funcionalidad está bajo la responsabilidad del cliente final.
      v-container#billing-table(fluid='' tag='section')
        v-row
          v-col(cols='12' md='12' style='padding: 0px;')
            v-tabs(v-model="tabsNote" grow="" icons-and-text="" height="35px")
              v-tab(ripple href='#tab-1')   Venta
              v-tab(ripple href='#tab-2')   Compra
              v-tab-item(value='tab-1')
                v-row(style="padding-top: 30px;")
                  v-col(cols='12' md='12' v-if="profile ? profile.twoAccounts : false" style="padding-top: 0px;")
                    v-select(style="margin-top: 0px; font-size: 26px; height: 30px;" hide-details="" return-object v-model='selectAccount' :items="acoountsLst" label="Seleccione la cuenta" item-text='texto')
                  v-col(cols="12" md="6" style="margin-top: 22px;")
                    v-menu(ref='menuFromNote' v-model='menuFromNote' :close-on-content-click='false' :return-value.sync='dateFromNote' transition='scale-transition' offset-y='' min-width='290px')
                      template(v-slot:activator='{ on }')
                        v-text-field(readonly v-model='dateFromNote' label='Buscar Desde' prepend-icon='mdi-calendar' v-on='on')
                      v-date-picker(@change='$refs.menuFromNote.save(dateFromNote)' v-model='dateFromNote' no-title='' scrollable='' :max="dateUntilNote" style='margin:0px;' color="green lighten-1" :min="minDateForConsults")
                  v-col(cols="10" md="5" style="margin-top: 22px;")
                    v-menu(ref='menuUntilNote' v-model='menuUntilNote' :close-on-content-click='false' :return-value.sync='dateUntilNote' transition='scale-transition' offset-y='' min-width='290px')
                      template(v-slot:activator='{ on }')
                        v-text-field(readonly v-model='dateUntilNote' label='Buscar Hasta' prepend-icon='mdi-calendar' v-on='on')
                      v-date-picker(@change='$refs.menuUntilNote.save(dateUntilNote)' v-model='dateUntilNote' no-title='' scrollable='' :min="dateFromNote" style='margin:0px;' color="green lighten-1")
                  v-col(cols="2" md="1" style="margin-top: 30px;")
                    v-tooltip(bottom='')
                      template(v-slot:activator='{ attrs, on }')
                        v-btn(v-on="on" icon='' color='gray' style="background-color: RGB(1, 125, 71);" @click="filterByDateNote")
                          v-icon(style="font-size: 30px; color: white;") mdi-magnify
                      span.tooltips FILTRAR POR FECHA
                  v-col(cols="12" md="6" style="margin-bottom: 20px; padding-top: 0px;")
                    v-text-field(v-model="search" append-icon="mdi-search" label= "Buscar" single-line="" hide-details="" clearable)
                  v-col(cols="12" md="3" style="padding-top: 0px;")
                    v-btn.mr-0(color='primary' rounded='' @click='addNewSaleNote'  style="width: 100%; margin-top: 7px;")
                      strong
                        | NUEVA
                        br
                        | NOTA
                  v-col(cols="12" md="3" style="padding-top: 0px;")
                    v-btn.mr-0(color='secondary' rounded='' style="width: 100%; margin-top: 7px;" @click='downLoadExcelFileSale' )
                      strong
                        | DESCARGAR
                        br
                        | LISTA
                v-skeleton-loader(:loading="cargando" type="table" v-if="firstLoad")
                v-data-table.mx-2#tablaDatos(v-if="selectAccount.code == '001'" :headers="headersNoteSale" v-show="!firstLoad" :items="notesSaleLst" item-key="id" :search="search" dense fixed-header :loading="cargando" loading-text="Cargando" :sort-by="ordenarPor" calculate-widths :footer-props="{\'items-per-page-text':'Notas por página'\}")
                  template(v-slot:[`item.totalView`]='{ item }') $ {{ item.total }}
                  template(v-slot:item.estado="{ item }")
                    v-chip(:color="getColor(item.estado)" small label) {{ item.estado ? 'ACTIVA' : 'ANULADA' }}
                  template(v-slot:item.action="{ item }")
                    v-tooltip(bottom="")
                      template(v-slot:activator="{ on }")
                        v-btn(text="" icon="" color='green' v-on="on" @click="editNoteSale(item)")
                          v-icon(small) mdi-eye
                      span.tooltips Visualizar Nota
                    v-tooltip(bottom="")
                      template(v-slot:activator="{ on }")
                        v-btn(:disabled="!item.estado" text="" icon="" color='red' v-on="on" @click="openAnulNoteSale(item)")
                          v-icon(small) mdi-trash-can-outline
                      span.tooltips Anular Nota
                    v-tooltip(bottom="")
                      template(v-slot:activator="{ on }")
                        v-btn(text="" icon="" color='brown' v-on="on" @click="printFactura(item)" :loading="loadingPrintFac")
                          v-icon(small) mdi-printer
                      span.tooltips Imprimir Nota
                  //- Mensaje de alerta cuando no hay resultados
                  v-alert.pa-0.ma-0(slot='no-results', :value='true', color='error', icon='mdi-alert-octagon-outline')
                    | Sin resultados
                  v-alert.pa-0.ma-0(slot='no-data', :value='true', color='info', icon='mdi-information-outline')
                    | Sin datos
                  v-flex(xs12='', sm10='', offset-sm1='')
                v-data-table.mx-2#tablaDatos(v-if="selectAccount.code == '002'" :headers="headersNoteSale" v-show="!firstLoad" :items="notesSaleLst2" item-key="id" :search="search" dense fixed-header :loading="cargando" loading-text="Cargando" :sort-by="ordenarPor" calculate-widths :footer-props="{\'items-per-page-text':'Notas por página'\}")
                  template(v-slot:[`item.totalView`]='{ item }') $ {{ item.total }}
                  template(v-slot:item.estado="{ item }")
                    v-chip(:color="getColor(item.estado)" small label) {{ item.estado ? 'ACTIVA' : 'ANULADA' }}
                  template(v-slot:item.action="{ item }")
                    v-tooltip(bottom="")
                      template(v-slot:activator="{ on }")
                        v-btn(text="" icon="" color='green' v-on="on" @click="editNoteSale(item)")
                          v-icon(small) mdi-eye
                      span.tooltips Visualizar Nota
                    v-tooltip(bottom="")
                      template(v-slot:activator="{ on }")
                        v-btn(:disabled="!item.estado" text="" icon="" color='red' v-on="on" @click="openAnulNoteSale(item)")
                          v-icon(small) mdi-trash-can-outline
                      span.tooltips Anular Nota
                    v-tooltip(bottom="")
                      template(v-slot:activator="{ on }")
                        v-btn(text="" icon="" color='brown' v-on="on" @click="printFactura(item)" :loading="loadingPrintFac")
                          v-icon(small) mdi-printer
                      span.tooltips Imprimir Nota
                  //- Mensaje de alerta cuando no hay resultados
                  v-alert.pa-0.ma-0(slot='no-results', :value='true', color='error', icon='mdi-alert-octagon-outline')
                    | Sin resultados
                  v-alert.pa-0.ma-0(slot='no-data', :value='true', color='info', icon='mdi-information-outline')
                    | Sin datos
                  v-flex(xs12='', sm10='', offset-sm1='')
              v-tab-item(value='tab-2')
                v-row(style="padding-top: 30px;")
                  v-col(cols="12" md="6" style="margin-bottom: 20px;")
                    v-text-field(v-model="search" append-icon="mdi-search" label= "Buscar" single-line="" hide-details="" clearable)
                  v-col(cols="12" md="3")
                    v-btn.mr-0(color='primary' rounded='' style="width: 100%;" @click='addNewPurchase' )
                      strong
                        | NUEVA
                        br
                        | NOTA
                  v-col(cols="12" md="3")
                    v-btn.mr-0(color='secondary' rounded='' style="width: 100%;" @click='downLoadExcelFilePurchase' )
                      strong
                        | DESCARGAR
                        br
                        | LISTA
                v-skeleton-loader(:loading="cargando" type="table" v-if="firstLoad")
                v-data-table.mx-2#tablaDatos(:headers="headersNotePurchase" v-show="!firstLoad" :items="notesPurchaseLst" item-key="id" :search="search" dense fixed-header :loading="cargando" loading-text="Cargando" calculate-widths)
                  template(v-slot:[`item.totalView`]='{ item }') $ {{ item.total }}
                  template(v-slot:item.estado="{ item }")
                    v-chip(:color="getColor(item.estado)" small label) {{ item.estado ? 'ACTIVA' : 'ANULADA' }}
                  template(v-slot:item.action="{ item }")
                    v-tooltip(bottom="")
                      template(v-slot:activator="{ on }")
                        v-btn(text="" icon="" color='green' v-on="on" @click="editNotePurchase(item)")
                          v-icon(small) mdi-eye
                      span.tooltips Visualizar Nota
                    v-col(cols="2" md="2")
                      v-tooltip(bottom="")
                        template(v-slot:activator="{ on }")
                          v-btn(:disabled="!item.pendientepago || !item.estado" text="" icon="" color='green' v-on="on" @click="openPayFacturaSale(item)")
                            v-icon(small) mdi-cash
                        span.tooltips Pagar Factura
                    v-tooltip(bottom="")
                      template(v-slot:activator="{ on }")
                        v-btn(:disabled="!item.estado" text="" icon="" color='red' v-on="on" @click="openAunlNotePurchase(item)")
                          v-icon(small) mdi-trash-can-outline
                      span.tooltips Anular Nota
                    v-tooltip(bottom="")
                      template(v-slot:activator="{ on }")
                        v-btn(text="" icon="" color='brown' v-on="on" @click="printPurchaseFactura(item)" :loading="loadingPrintFac")
                          v-icon(small) mdi-printer
                      span.tooltips Imprimir Nota
                  //- Mensaje de alerta cuando no hay resultados
                  v-alert.pa-0.ma-0(slot='no-results', :value='true', color='error', icon='mdi-alert-octagon-outline')
                    | Sin resultados
                  v-alert.pa-0.ma-0(slot='no-data', :value='true', color='info', icon='mdi-information-outline')
                    | Sin datos
                  v-flex(xs12='', sm10='', offset-sm1='')
</template>
<script>
  import moment from 'moment'
  import * as functions from '../../../functions.js'
  import * as printerFunctions from '../../../functions/printerFunctions.js'
  import * as printerFunctionsNote from '../../../functions/printerFunctionsNote.js'
  import * as printerPurchaseFunctions from '../../../functions/printerPurchaseFunction.js'
  export default {
    components: {
      SaleNote: () => import('@/views/dashboard/component/application/SaleNote'),
      PurchaseNote: () => import('@/views/dashboard/component/application/PurchaseNote'),
    },
    data: () => ({
      minDateForConsults: moment().subtract(15, 'days').format('YYYY-MM-DD'),
      profile: null,
      selectAccount: {
        code: '001',
        texto: 'Ingresar datos de la Cuenta 1.',
      },
      acoountsLst: [
        {
          code: '001',
          texto: 'Ingresar datos de la Cuenta 1.',
        },
        {
          code: '002',
          texto: 'Ingresar datos de la Cuenta 2.',
        },
      ],
      banSendNotePurchase: '0',
      banSendFac: '0',
      menuFromNote: false,
      menuUntilNote: false,
      dateUntilNote: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().substr(0, 10),
      dateFromNote: moment(new Date()).format('YYYY-MM-DD'),
      alertDataSend: true,
      loadingPrintFac: false,
      snackbar: {
        show: false,
        text: '',
        color: '',
      },
      notePurchaseSelected: null,
      confirmationDialogPurchase: false,
      dialodPurchase: false,
      loadingSave: false,
      noteSaleSelected: null,
      confirmationDialogSale: false,
      dialogSale: false,
      tabsNote: 'tab-1',
      search: '',
      cargando: false,
      firstLoad: false,
      ordenarPor: 'numero',
      headersNoteSale: [
        { text: 'Secuencia', value: 'numsecuencial', align: 'left', filterable: true },
        { text: 'Fecha de Emisión', value: 'fechaEmision', align: 'left', filterable: true },
        // { text: 'Descripción', value: 'descripcion', align: 'left', filterable: true },
        { text: 'TOTAL', value: 'totalView', align: 'left', filterable: true },
        { text: 'ESTADO', value: 'estado', align: 'left', filterable: true },
        { text: 'ACCIONES', align: 'center', value: 'action', sortable: false },
      ],
      headersNotePurchase: [
        { text: 'Secuencia', value: 'numsecuencial', align: 'left', filterable: true },
        { text: 'Fecha de Emisión', value: 'fechaEmision', align: 'left', filterable: true },
        // { text: 'Descripción', value: 'descripcion', align: 'left', filterable: true },
        { text: 'TOTAL', value: 'totalView', align: 'left', filterable: true },
        { text: 'ESTADO', value: 'estado', align: 'left', filterable: true },
        { text: 'ACCIONES', align: 'center', value: 'action', sortable: false },
      ],
      noteToEdit: {
        numsecuencial: '',
        client: null,
        fechaEmision: moment(new Date()).format('YYYY-MM-DD'),
        descripcion: '',
        lstProductos: [],
        total: '0.00',
        pendientepago: false,
        fechapago: moment(new Date()).format('YYYY-MM-DD'),
        quitIvaNote: false,
      },
    }),
    computed: {
      companyDataLoad () {
        return this.$store.state.facturacion.companydata
      },
      plan () {
        return this.$store.state.suscriptionPlan.plan
      },
      notesSaleLst () {
        return this.$store.state.factura.noteSaleLst
      },
      notesSaleLst2 () {
        return this.$store.state.factura.noteSale2Lst
      },
      notesPurchaseLst () {
        return this.$store.state.factura.notePurchaseLst
      },
      profileLoaded () {
        return this.$store.state.profile.profileLoaded
      },
    },
    watch: {
      plan () {
        if (this.plan.diasConsulta) {
          this.minDateForConsults = moment().subtract(this.plan.diasConsulta, 'days').format('YYYY-MM-DD')
        }
      },
      profileLoaded () {
        if (this.profileLoaded) this.profile = this.profileLoaded
        if (this.profile) {
          if (!this.profile.rucEstablecimieto || !this.profile.razonSocial) {
            this.snackbar = {
              show: true,
              color: 'orange',
              text: 'Para continuar debe completar sus datos de PERFIL.',
            }
            setTimeout(() => {
              this.$router.push('/pages/user')
            }, 3000)
            return
          }
          if (this.profile.rucEstablecimieto === '' || this.profile.rucEstablecimieto === null || this.profile.razonSocial === '' || this.profile.razonSocial === null) {
            this.snackbar = {
              show: true,
              color: 'orange',
              text: 'Para continuar debe completar sus datos de PERFIL.',
            }
            setTimeout(() => {
              this.$router.push('/pages/user')
            }, 3000)
            return
          }
          if (this.profile.rucEstablecimieto) {
            if (this.selectAccount.code !== '002') {
              this.selectAccount = {
                code: '001',
                texto: this.profile.rucEstablecimieto !== '' ? this.profile.rucEstablecimieto + ' - ' + this.profile.razonSocial : 'Ingresar datos de la Cuenta 1.',
              }
            }
            this.acoountsLst = [
              {
                code: '001',
                texto: this.profile.rucEstablecimieto !== '' ? this.profile.rucEstablecimieto + ' - ' + this.profile.razonSocial : 'Ingresar datos de la Cuenta 1.',
              },
              {
                code: '002',
                texto: 'Ingresar datos de la Cuenta 2.',
              },
            ]
            if (this.profile.rucEstablecimieto2) {
              this.acoountsLst = [
                {
                  code: '001',
                  texto: this.profile.rucEstablecimieto !== '' ? this.profile.rucEstablecimieto + ' - ' + this.profile.razonSocial : 'Ingresar datos de la Cuenta 1.',
                },
                {
                  code: '002',
                  texto: this.profile.rucEstablecimieto2 !== '' ? this.profile.rucEstablecimieto2 + ' - ' + this.profile.razonSocial2 : 'Ingresar datos de la Cuenta 2.',
                },
              ]
            }
          }
        }
        const lstProducts = this.$store.state.product.lstProductsActive
        const lstCombos = this.$store.state.product.lstCombos
        if (lstProducts.length === 0 && lstCombos.length === 0) {
          this.snackbar = {
            show: true,
            color: 'orange',
            text: 'Para continuar debe agregar sus PRODUCTOS.',
          }
          setTimeout(() => {
            this.$router.push('/pages/inventorydata')
          }, 3000)
        }
      },
    },
    mounted () {
      if (this.plan.diasConsulta) {
        this.minDateForConsults = moment().subtract(this.plan.diasConsulta, 'days').format('YYYY-MM-DD')
      }
      this.alertDataSend = true
      this.profile = this.$store.state.profile.profileLoaded
      if (this.profile) {
        if (!this.profile.rucEstablecimieto || !this.profile.razonSocial) {
          this.snackbar = {
            show: true,
            color: 'orange',
            text: 'Para continuar debe completar sus datos de PERFIL.',
          }
          setTimeout(() => {
            this.$router.push('/pages/user')
          }, 3000)
          return
        }
        if (this.profile.rucEstablecimieto === '' || this.profile.rucEstablecimieto === null || this.profile.razonSocial === '' || this.profile.razonSocial === null) {
          this.snackbar = {
            show: true,
            color: 'orange',
            text: 'Para continuar debe completar sus datos de PERFIL.',
          }
          setTimeout(() => {
            this.$router.push('/pages/user')
          }, 3000)
          return
        }
        if (this.profile.rucEstablecimieto) {
          this.selectAccount = {
            code: '001',
            texto: this.profile.rucEstablecimieto !== '' ? this.profile.rucEstablecimieto + ' - ' + this.profile.razonSocial : 'Ingresar datos de la Cuenta 1.',
          }
          this.acoountsLst = [
            {
              code: '001',
              texto: this.profile.rucEstablecimieto !== '' ? this.profile.rucEstablecimieto + ' - ' + this.profile.razonSocial : 'Ingresar datos de la Cuenta 1.',
            },
            {
              code: '002',
              texto: 'Ingresar datos de la Cuenta 2.',
            },
          ]
          if (this.profile.rucEstablecimieto2) {
            this.acoountsLst = [
              {
                code: '001',
                texto: this.profile.rucEstablecimieto !== '' ? this.profile.rucEstablecimieto + ' - ' + this.profile.razonSocial : 'Ingresar datos de la Cuenta 1.',
              },
              {
                code: '002',
                texto: this.profile.rucEstablecimieto2 !== '' ? this.profile.rucEstablecimieto2 + ' - ' + this.profile.razonSocial2 : 'Ingresar datos de la Cuenta 2.',
              },
            ]
          }
        }
      }
      const lstProducts = this.$store.state.product.lstProductsActive
      const lstCombos = this.$store.state.product.lstCombos
      if (lstProducts.length === 0 && lstCombos.length === 0) {
        this.snackbar = {
          show: true,
          color: 'orange',
          text: 'Para continuar debe agregar sus PRODUCTOS.',
        }
        setTimeout(() => {
          this.$router.push('/pages/inventorydata')
        }, 3000)
      }
    },
    methods: {
      filterByDateNote () {
        const data = {
          firstDay: this.dateFromNote,
          lastDay: this.dateUntilNote,
        }
        this.$store.dispatch('factura/loadNoteSaleFilter', data)
        this.$store.dispatch('factura/loadNoteSaleFilter2', data)
      },
      async printFactura (item) {
        let myWindow = null
        if (this.$store.state.profile.profileLoaded.print || this.$store.state.profile.profileLoaded.printNormal) {
          myWindow = window.open('', 'print-note', 'fullscreen="yes"')
        }
        this.loadingPrintFac = true
        item.saldo = item.total
        let imgBs64 = 'data:image/png;base64,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'
        if (this.$store.state.profile.profileLoaded.print || this.$store.state.profile.profileLoaded.printNormal) {
          this.$store.dispatch('facturacion/getComanyImg', this.$store.state.profile.profileLoaded.urlImg)
            .then(async dataUrl => {
              if (dataUrl) {
                imgBs64 = dataUrl
                item.companyData = this.companyDataLoad
                await functions.printDataNote(item, this.$store.state.profile.profileLoaded, 'print-note', imgBs64, myWindow)
                if (this.profile.doubleNotePrinting) {
                  await functions.printVoucher(item, this.$store.state.profile.profileLoaded, 'print-voucher')
                }
              }
            })
        }
        if (this.$store.state.profile.profileLoaded.urlImg) {
          if (this.$store.state.profile.profileLoaded.urlImg !== '') {
            this.$store.dispatch('facturacion/getComanyImg', this.$store.state.profile.profileLoaded.urlImg)
              .then(dataUrl => {
                imgBs64 = dataUrl
                if (item.quitIvaNote) {
                  printerFunctionsNote.printSaleBilling(item, this.$store.state.profile.profileLoaded, imgBs64, 'Nota de Venta').then(res => {
                    this.loadingPrintFac = false
                  })
                } else {
                  printerFunctions.printSaleBilling(item, this.$store.state.profile.profileLoaded, imgBs64, 'Nota de Venta').then(res => {
                    this.loadingPrintFac = false
                  })
                }
              })
          } else {
            if (item.quitIvaNote) {
              printerFunctionsNote.printSaleBilling(item, this.$store.state.profile.profileLoaded, imgBs64, 'Nota de Venta').then(res => {
                this.loadingPrintFac = false
              })
            } else {
              printerFunctions.printSaleBilling(item, this.$store.state.profile.profileLoaded, imgBs64, 'Nota de Venta').then(res => {
                this.loadingPrintFac = false
              })
            }
          }
        } else {
          if (item.quitIvaNote) {
            printerFunctionsNote.printSaleBilling(item, this.$store.state.profile.profileLoaded, imgBs64, 'Nota de Venta').then(res => {
              this.loadingPrintFac = false
            })
          } else {
            printerFunctions.printSaleBilling(item, this.$store.state.profile.profileLoaded, imgBs64, 'Nota de Venta').then(res => {
              this.loadingPrintFac = false
            })
          }
        }
      },
      printPurchaseFactura (item) {
        this.loadingPrintFac = true
        item.subtotal = item.total
        item.saldo = item.total
        let imgBs64 = 'data:image/png;base64,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'
        if (this.$store.state.profile.profileLoaded.urlImg) {
          if (this.$store.state.profile.profileLoaded.urlImg !== '') {
            this.$store.dispatch('facturacion/getComanyImg', this.$store.state.profile.profileLoaded.urlImg)
              .then(dataUrl => {
                imgBs64 = dataUrl
                printerPurchaseFunctions.printSaleBilling(item, this.$store.state.profile.profileLoaded, imgBs64, 'Nota de Compra').then(res => {
                  this.loadingPrintFac = false
                })
              })
          } else {
            printerPurchaseFunctions.printSaleBilling(item, this.$store.state.profile.profileLoaded, imgBs64, 'Nota de Compra').then(res => {
              this.loadingPrintFac = false
            })
          }
        } else {
          printerPurchaseFunctions.printSaleBilling(item, this.$store.state.profile.profileLoaded, imgBs64, 'Nota de Compra').then(res => {
            this.loadingPrintFac = false
          })
        }
      },
      anulNotePurchase () {
        if (this.banSendNotePurchase === '0') {
          this.banSendNotePurchase = '1'
          setTimeout(() => {
            this.banSendNotePurchase = '0'
          }, 1000)
          this.loadingSave = true
          this.notePurchaseSelected.estado = false
          this.$store.dispatch('factura/anulNotePurchase', this.notePurchaseSelected).then(res => {
            this.loadingSave = false
            this.confirmationDialogPurchase = false
            this.snackbar = {
              show: true,
              color: 'green',
              text: 'Nota de compra anulada de manera correcta.',
            }
          }, reject => {
            this.loadingSave = false
            this.snackbar = {
              show: true,
              color: 'red',
              text: 'Error al momento de anular la nota de compra.',
            }
          })
        }
      },
      openAunlNotePurchase (item) {
        this.notePurchaseSelected = item
        this.confirmationDialogPurchase = true
      },
      downLoadExcelFilePurchase () {
        const data = []
        if (this.notesPurchaseLst) {
          for (let i = 0; i < this.notesPurchaseLst.length; i++) {
            data.push({
              'Fecha de Emisión': this.notesPurchaseLst[i].fechaEmision,
              // Proveedor: this.notesPurchaseLst[i].proveedor.completeData,
              Decripción: this.notesPurchaseLst[i].descripcion,
              // IVA: this.notesPurchaseLst[i].iva12,
              Total: this.notesPurchaseLst[i].total.replace('.', ','),
              // Saldo: this.facturasPurchaseLst[i].saldo,
            })
          }
          functions.JSONToCSVConvertor(data, 'Notas de Compra', true)
        }
      },
      editNotePurchase (item) {
        this.dialodPurchase = true
        this.noteToEdit = item
      },
      addNewPurchase () {
        let proveedorVal = null
        if (this.$store.state.provider.lstProviders.length > 0) {
          proveedorVal = this.$store.state.provider.lstProviders[0]
        }
        this.noteToEdit = {
          numsecuencial: '',
          fechaEmision: moment(new Date()).format('YYYY-MM-DD'),
          descripcion: '',
          provider: proveedorVal,
          lstProductos: [],
          total: '0.00',
          subtotal: '0.00',
          iva12: '0.00',
          pendientepago: false,
          fechapago: moment(new Date()).format('YYYY-MM-DD'),
          quitIvaNote: false,
        }
        this.dialodPurchase = true
      },
      anulNoteSale () {
        if (this.banSendFac === '0') {
          this.banSendFac = '1'
          setTimeout(() => {
            this.banSendFac = '0'
          }, 1000)
          this.loadingSave = true
          this.noteSaleSelected.estado = false
          this.$store.dispatch('factura/anulNoteSale', this.noteSaleSelected).then(res => {
            this.loadingSave = false
            this.confirmationDialogSale = false
            this.snackbar = {
              show: true,
              color: 'green',
              text: 'Nota de venta anulada de manera correcta.',
            }
          }, reject => {
            this.loadingSave = false
            this.snackbar = {
              show: true,
              color: 'red',
              text: 'Error al momento de anular la nota de venta.',
            }
          })
        }
      },
      openAnulNoteSale (item) {
        this.noteSaleSelected = item
        this.confirmationDialogSale = true
      },
      downLoadExcelFileSale () {
        const data = []
        let notesSaleLstFinal = []
        if (this.selectAccount.code === '001') {
          notesSaleLstFinal = this.notesSaleLst
        } else {
          notesSaleLstFinal = this.notesSaleLst2
        }
        if (notesSaleLstFinal) {
          for (let i = 0; i < notesSaleLstFinal.length; i++) {
            data.push({
              'Fecha de Emisión': notesSaleLstFinal[i].fechaEmision,
              // Proveedor: notesSaleLstFinal[i].proveedor.completeData,
              Cliente: notesSaleLstFinal[i].client.completeData,
              Decripción: notesSaleLstFinal[i].descripcion,
              // IVA: notesSaleLstFinal[i].iva12,
              Total: notesSaleLstFinal[i].total.replace('.', ','),
            })
          }
          functions.JSONToCSVConvertor(data, 'Notas de Venta', true)
        }
      },
      editNoteSale (item) {
        this.dialogSale = true
        this.noteToEdit = item
      },
      addNewSaleNote () {
        this.noteToEdit = {
          client: {
            idType: {
              codigo: '07',
              texto: 'VENTA A CONSUMIDOR FINAL*',
            },
            address: 'Consumidor Final',
            clientKey: 'consumidorfinal',
            completeData: 'Consumidor Final | 9999999999999',
            lastName: 'Final',
            mail: '',
            businessName: '',
            name: 'Consumidor',
            phone: '',
            cellphone: '0999999999',
            ide: '9999999999999',
            id: 'consumidorfinal',
            viewName: 'Consumidor Final',
          },
          numsecuencial: '',
          fechaEmision: moment(new Date()).format('YYYY-MM-DD'),
          descripcion: '',
          lstProductos: [],
          subtotal: '0.00',
          iva12: '0.00',
          total: '0.00',
          totdcto: '0.00',
          pendientepago: false,
          fechapago: moment(new Date()).format('YYYY-MM-DD'),
          quitIvaNote: false,
        }
        this.dialogSale = true
      },
      closeModalSale () {
        this.dialogSale = false
      },
      closeModalPurchase () {
        this.dialodPurchase = false
      },
      getColor (valor) {
        if (valor === true) {
          return 'green'
        } else {
          return 'red'
        }
      },
    },
  }
</script>
